import { render, staticRenderFns } from "./materialPrice.vue?vue&type=template&id=0ff5f04a&scoped=true&"
import script from "./materialPrice.vue?vue&type=script&lang=js&"
export * from "./materialPrice.vue?vue&type=script&lang=js&"
import style0 from "./materialPrice.vue?vue&type=style&index=0&id=0ff5f04a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff5f04a",
  null
  
)

export default component.exports